"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.centroid = centroid;
exports["default"] = void 0;

var _Interaction = _interopRequireDefault(require("./Interaction.js"));

var _MapBrowserEventType = _interopRequireDefault(require("../MapBrowserEventType.js"));

var _obj = require("../obj.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/interaction/Pointer
 */


/**
 * @typedef {Object} Options
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleDownEvent]
 * Function handling "down" events. If the function returns `true` then a drag
 * sequence is started.
 * @property {function(import("../MapBrowserEvent.js").default):void} [handleDragEvent]
 * Function handling "drag" events. This function is called on "move" events
 * during a drag sequence.
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleEvent]
 * Method called by the map to notify the interaction that a browser event was
 * dispatched to the map. The function may return `false` to prevent the
 * propagation of the event to other interactions in the map's interactions
 * chain.
 * @property {function(import("../MapBrowserEvent.js").default):void} [handleMoveEvent]
 * Function handling "move" events. This function is called on "move" events.
 * This functions is also called during a drag sequence, so during a drag
 * sequence both the `handleDragEvent` function and this function are called.
 * If `handleDownEvent` is defined and it returns true this function will not
 * be called during a drag sequence.
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleUpEvent]
 *  Function handling "up" events. If the function returns `false` then the
 * current drag sequence is stopped.
 * @property {function(boolean):boolean} [stopDown]
 * Should the down event be propagated to other interactions, or should be
 * stopped?
 */

/**
 * @classdesc
 * Base class that calls user-defined functions on `down`, `move` and `up`
 * events. This class also manages "drag sequences".
 *
 * When the `handleDownEvent` user function returns `true` a drag sequence is
 * started. During a drag sequence the `handleDragEvent` user function is
 * called on `move` events. The drag sequence ends when the `handleUpEvent`
 * user function is called and returns `false`.
 * @api
 */
var PointerInteraction =
/** @class */
function (_super) {
  __extends(PointerInteraction, _super);
  /**
   * @param {Options} [opt_options] Options.
   */


  function PointerInteraction(opt_options) {
    var _this = this;

    var options = opt_options ? opt_options : {};
    _this = _super.call(this,
    /** @type {import("./Interaction.js").InteractionOptions} */
    options) || this;

    if (options.handleDownEvent) {
      _this.handleDownEvent = options.handleDownEvent;
    }

    if (options.handleDragEvent) {
      _this.handleDragEvent = options.handleDragEvent;
    }

    if (options.handleMoveEvent) {
      _this.handleMoveEvent = options.handleMoveEvent;
    }

    if (options.handleUpEvent) {
      _this.handleUpEvent = options.handleUpEvent;
    }

    if (options.stopDown) {
      _this.stopDown = options.stopDown;
    }
    /**
     * @type {boolean}
     * @protected
     */


    _this.handlingDownUpSequence = false;
    /**
     * @type {!Object<string, PointerEvent>}
     * @private
     */

    _this.trackedPointers_ = {};
    /**
     * @type {Array<PointerEvent>}
     * @protected
     */

    _this.targetPointers = [];
    return _this;
  }
  /**
   * Returns the current number of pointers involved in the interaction,
   * e.g. `2` when two fingers are used.
   * @return {number} The number of pointers.
   * @api
   */


  PointerInteraction.prototype.getPointerCount = function () {
    return this.targetPointers.length;
  };
  /**
   * Handle pointer down events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @protected
   */


  PointerInteraction.prototype.handleDownEvent = function (mapBrowserEvent) {
    return false;
  };
  /**
   * Handle pointer drag events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @protected
   */


  PointerInteraction.prototype.handleDragEvent = function (mapBrowserEvent) {};
  /**
   * Handles the {@link module:ol/MapBrowserEvent~MapBrowserEvent map browser event} and may call into
   * other functions, if event sequences like e.g. 'drag' or 'down-up' etc. are
   * detected.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
   * @return {boolean} `false` to stop event propagation.
   * @api
   */


  PointerInteraction.prototype.handleEvent = function (mapBrowserEvent) {
    if (!mapBrowserEvent.originalEvent) {
      return true;
    }

    var stopEvent = false;
    this.updateTrackedPointers_(mapBrowserEvent);

    if (this.handlingDownUpSequence) {
      if (mapBrowserEvent.type == _MapBrowserEventType["default"].POINTERDRAG) {
        this.handleDragEvent(mapBrowserEvent); // prevent page scrolling during dragging

        mapBrowserEvent.originalEvent.preventDefault();
      } else if (mapBrowserEvent.type == _MapBrowserEventType["default"].POINTERUP) {
        var handledUp = this.handleUpEvent(mapBrowserEvent);
        this.handlingDownUpSequence = handledUp && this.targetPointers.length > 0;
      }
    } else {
      if (mapBrowserEvent.type == _MapBrowserEventType["default"].POINTERDOWN) {
        var handled = this.handleDownEvent(mapBrowserEvent);
        this.handlingDownUpSequence = handled;
        stopEvent = this.stopDown(handled);
      } else if (mapBrowserEvent.type == _MapBrowserEventType["default"].POINTERMOVE) {
        this.handleMoveEvent(mapBrowserEvent);
      }
    }

    return !stopEvent;
  };
  /**
   * Handle pointer move events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @protected
   */


  PointerInteraction.prototype.handleMoveEvent = function (mapBrowserEvent) {};
  /**
   * Handle pointer up events.
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @return {boolean} If the event was consumed.
   * @protected
   */


  PointerInteraction.prototype.handleUpEvent = function (mapBrowserEvent) {
    return false;
  };
  /**
   * This function is used to determine if "down" events should be propagated
   * to other interactions or should be stopped.
   * @param {boolean} handled Was the event handled by the interaction?
   * @return {boolean} Should the `down` event be stopped?
   */


  PointerInteraction.prototype.stopDown = function (handled) {
    return handled;
  };
  /**
   * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
   * @private
   */


  PointerInteraction.prototype.updateTrackedPointers_ = function (mapBrowserEvent) {
    if (isPointerDraggingEvent(mapBrowserEvent)) {
      var event_1 = mapBrowserEvent.originalEvent;
      var id = event_1.pointerId.toString();

      if (mapBrowserEvent.type == _MapBrowserEventType["default"].POINTERUP) {
        delete this.trackedPointers_[id];
      } else if (mapBrowserEvent.type == _MapBrowserEventType["default"].POINTERDOWN) {
        this.trackedPointers_[id] = event_1;
      } else if (id in this.trackedPointers_) {
        // update only when there was a pointerdown event for this pointer
        this.trackedPointers_[id] = event_1;
      }

      this.targetPointers = (0, _obj.getValues)(this.trackedPointers_);
    }
  };

  return PointerInteraction;
}(_Interaction["default"]);
/**
 * @param {Array<PointerEvent>} pointerEvents List of events.
 * @return {import("../pixel.js").Pixel} Centroid pixel.
 */


function centroid(pointerEvents) {
  var length = pointerEvents.length;
  var clientX = 0;
  var clientY = 0;

  for (var i = 0; i < length; i++) {
    clientX += pointerEvents[i].clientX;
    clientY += pointerEvents[i].clientY;
  }

  return [clientX / length, clientY / length];
}
/**
 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
 * @return {boolean} Whether the event is a pointerdown, pointerdrag
 *     or pointerup event.
 */


function isPointerDraggingEvent(mapBrowserEvent) {
  var type = mapBrowserEvent.type;
  return type === _MapBrowserEventType["default"].POINTERDOWN || type === _MapBrowserEventType["default"].POINTERDRAG || type === _MapBrowserEventType["default"].POINTERUP;
}

var _default = PointerInteraction;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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